export const ADD_LEFT_PANEL_MODIFIER = 'add-left-panel-modifier'
export const REMOVE_LEFT_PANEL_MODIFIER = 'remove-left-panel-modifier'

export const ADD_RIGHT_PANEL_MODIFIER = 'add-right-panel-modifier'
export const REMOVE_RIGHT_PANEL_MODIFIER = 'remove-right-panel-modifier'

export const ADD_CANVAS_TOP_BAR_MODIFIER = 'add-canvas-top-bar-modifier'
export const REMOVE_CANVAS_TOP_BAR_MODIFIER = 'remove-canvas-top-bar-modifier'
